<template>
  <ModalDialog
    ref="dialog"
    title="Send Customer Statements"
    :submitting="submitting"
    :scrollable="true"
    submitTitle="Send"
    icon="fa-envelope-open-text"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="dialogForm">
      <div>
        <p class="font-weight-bold">{{selectedContactCount}} contact{{selectedContactCount | displayCountPlural}} selected for emailing statements</p>
        <FormHorizontalRule />
        <EmailMessageForm 
          :ccAvailable="false"
          :attachmentsAvailable="false"
          :contactListAvailable="false"
          :templateType="MessageTemplateTypes.customerStatement"
          :messageTemplateUpdateFn="messageTemplateUpdateFn"
          @uploading="currentlyUploading = $event"
          @update="emailDetails = $event"
        />
      </div>

    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'
import EmailMessageForm from '@/modules/core/components/emailMessageForm'

import { ApprovalTypes, MessageTemplateTypes, CommunicationMethodTypes } from '@/store/types'

export default {
  name: 'SendContactListStatementDialog',
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog,
    EmailMessageForm
  },
  props: {
    date: String,
    selectedContacts: Array
  },
  data() {
    return {
      responseInfo: {},
      dialogForm: {},
      emailDetails: {},
      submitting: false,
      messageTemplateUpdateFn: this.getMessageTemplateUpdatePromise,
    }
  },
  created() {
    this.MessageTemplateTypes = MessageTemplateTypes
  },
  mounted() {
  },
  computed: {
    selectedContactCount() {
      return this.selectedContacts.length
    }
  },
  methods: {
    show(stockData) {
      // Reset form
      this.emailData = { }
      this.responseInfo = { }
      this.dialogForm = { }

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      var statementData = {
        balanceDate: this.date,
        messageSubject: this.emailDetails.messageSubject,
        messageContent: this.emailDetails.messageContent,
        contactList: []
      }

      statementData.contactList = this.selectedContacts.map(contact => {
        return {
          id: contact.id,
          contactPersonId: contact.contactPersonId
        }
      })
     
      this.$apiService.accountsService.sendContactListStatements(statementData)
      .then(response => {
        this.modalClosed(true)
        this.hide()
      })
      .catch(err => {
        this.$data.dialogForm = this.processFormResponse(err)
      })
      .finally(() => {
        this.$data.submitting = false
      })
    },
    getMessageTemplateUpdatePromise(messageTemplateId) {
      return new Promise((resolve, reject) => {
        return this.$apiService.accountsService.getSendContactListStatementTemplate(messageTemplateId)
        .then(response => {
          return resolve(response.data)
        })
        .catch(err => { reject(err) })
      })
    }
  }
}
</script>